<template>
  <v-card id="AmbientalCard" class="Ecotrace-card">
    <v-card-text class="px-6 py-12">
      <v-row class="mb-4">
        <v-col>
          <div
            v-if="producerData.property_current_status === false"
            class="d-flex justify-center align-center shadow-container ambiental-title py-5 px-7"
          >
            <v-img
              src="@/assets/icons/selo_ambiental_problemas.png"
              max-width="58"
              max-height="80"
              class="mr-5"
            ></v-img>
            <h2 class="headline">
              {{ texts.propriedade_nao_conforme }}
            </h2>
          </div>
          <div
            v-else-if="producerData.property_current_status === true"
            class="d-flex justify-center align-center shadow-container ambiental-title py-5 px-7"
          >
            <v-img
              src="@/assets/icons/selo_ambiental.png"
              max-width="58"
              max-height="80"
              class="mr-5"
            ></v-img>
            <h2 class="headline">
              {{ texts.propriedade_conforme }}
            </h2>
          </div>
          <div
            v-else
            class="d-flex justify-center align-center shadow-container ambiental-title py-5 px-7"
          >
            <v-img
              src="@/assets/icons/selo_ambiental_problemas.png"
              max-width="58"
              max-height="80"
              class="mr-5"
            ></v-img>
            <h2 class="headline">
              {{ texts.propriedade_com_inconsistencia }}
            </h2>
          </div>
        </v-col>
      </v-row>
      <v-row
        class="justify-space-between align-stretch"
        v-for="(item, idx) in dataAmbiental"
        :key="idx"
      >
        <v-col cols="8" class="d-flex align-center">
          <span class="subtitle-1 font-weight-medium">{{
            item.name | zhCn({ texts })
          }}</span>
        </v-col>
        <v-col cols="4" class="d-flex align-center justify-center">
          <span
            v-if="producerData[item.api_key] === true"
            class="subtitle-1 font-weight-medium primary--text"
          >
            {{ texts.analise_status_conforme }}
          </span>
          <span
            v-else-if="producerData[item.api_key] === false"
            class="subtitle-1 font-weight-medium error--text"
          >
            {{ texts.analise_status_nao_conforme }}
          </span>
          <span v-else class="subtitle-1 font-weight-medium error--text">
            {{ texts.nada_consta }}
          </span>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col class="analysis-owner-wrapper" cols="12">
          <span class="subtitle-1 analysis-owner">
            {{ texts.empresa_responsavel_monitoramento }}:
          </span>
          <img
            alt="NicePlanet Geotecnologia"
            class="niceplanet-brand"
            src="../../assets/niceplanet.png"
            title="NicePlanet Geotecnologia"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['texts', 'track', 'show', 'trackOrigem'],

  data() {
    return {
      dataAmbiental: null,
      producerData: null
    }
  },

  filters: {
    zhCn(val, { texts }) {
      if (val in texts) return texts[val]
      return val
    }
  },

  created() {
    this.dataAmbiental = this.track.ambiental
    this.producerData = this.$store.state.producer_data.analysis
    this.$store.state.origem = false
  },

  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="scss" scoped>
#AmbientalCard::v-deep {
  .shadow-container.ambiental-title {
    h2 {
      display: inline-block;
    }
  }

  .shadow-container {
    box-shadow: 0px 3px 22px #00000017;
    border-radius: 11px;
  }

  .shadow-container.list-item {
    width: 70px;
    height: 70px;
    display: inline-block;
    padding: 19px 7px;
    text-align: center;
    margin-right: 18px;
  }
}

.analysis-owner-wrapper {
  display: flex;
  flex-direction: column;
}

.analysis-owner {
  color: $quaternary-color;
}

.niceplanet-brand {
  height: auto;
  margin: 0.5rem 0 0 0;
  max-width: 160px;
  object-fit: center;
  object-position: center;
  width: auto;
}
</style>
